<h4>Zoek Quickscans</h4>
<form [formGroup]="formGroup" (ngSubmit)="getFilteredQuickScans()">
  <mat-form-field appearance="outline" class="me-2">
    <mat-label>Start datum</mat-label>
    <input matInput [matDatepicker]="pickerStart" formControlName="startDate" [min]="minDate" [max]="maxDate" />
    <mat-datepicker-toggle matIconSuffix [for]="pickerStart" />
    <mat-datepicker #pickerStart />
  </mat-form-field>

  <mat-form-field appearance="outline" class="me-2">
    <mat-label>Eind datum</mat-label>
    <input matInput [matDatepicker]="pickerEnd" formControlName="endDate" [min]="minDate" [max]="maxDate" />
    <mat-datepicker-toggle matIconSuffix [for]="pickerEnd" />
    <mat-datepicker #pickerEnd />
  </mat-form-field>

  <mat-form-field appearance="outline" class="me-2">
    <mat-label>Klant</mat-label>
    <mat-select matInput formControlName="companyName">
      @for (customer of config.customers$ | async; track $index) {
      <mat-option [value]="customer">{{ customer }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button mat-stroked-button color="primary" type="submit" [disabled]="loading">Filter</button>
</form>
